import { useDispatch, useSelector } from "react-redux";
import Modal from "../UI/Modal";
import {
  closeFormModal,
  openViewModal,
} from "../../store/reducers/actividadesAplicacion/actividadesAplicacion.reducer";
import { useEffect, useState } from "react";
import {
  createMultiplesActividadesAplicacionThunk,
  updateActividadAplicacionThunk,
  getActividadesAplicacionThunk,
  getActividadAplicacionByIdThunk,
} from "../../store/reducers/actividadesAplicacion/actividadesAplicacion.thunks";
import Loader from "../UI/Loader";
import Alert from "../UI/Alert";
import Select2 from "../UI/Select2";
import { getTalentosSelectoresService } from "../../services/frases/frases.service";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

const ActivitiesApplicationFormModal = () => {
  const dispatch = useDispatch();
  const {
    formModalOpen,
    formMode,
    selectedActividad,
    formLoading,
    formError,
    page,
    search,
    talentoFilter,
  } = useSelector((state) => state.actividadesAplicacion);

  const [editFormData, setEditFormData] = useState({
    nombre: "",
    talento: null,
  });

  const [createFormData, setCreateFormData] = useState({
    talento: null,
    actividades: [{ actividad: "" }],
  });

  useEffect(() => {
    if (formMode === "edit" && selectedActividad) {
      setEditFormData({
        nombre: selectedActividad.nombre || selectedActividad.actividad || "",
        talento: selectedActividad.talento || null,
      });
    } else {
      setCreateFormData({
        talento: null,
        actividades: [{ actividad: "" }],
      });
    }
  }, [formMode, selectedActividad, formModalOpen]);

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresService(searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label }));
  };

  const handleActividadChange = (index, value) => {
    setCreateFormData((prev) => {
      const newActividades = [...prev.actividades];
      newActividades[index] = { actividad: value };
      return { ...prev, actividades: newActividades };
    });
  };

  const handleAddActividad = () => {
    setCreateFormData((prev) => ({
      ...prev,
      actividades: [...prev.actividades, { actividad: "" }],
    }));
  };

  const handleRemoveActividad = (index) => {
    setCreateFormData((prev) => ({
      ...prev,
      actividades: prev.actividades.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formMode === "create") {
      const validActividades = createFormData.actividades.filter(
        (a) => a.actividad.trim() !== "",
      );
      if (validActividades.length === 0) {
        toast.error("Debes agregar al menos una actividad");
        return;
      }

      const payload = {
        talento: createFormData.talento,
        actividades: validActividades,
      };

      const result = await dispatch(
        createMultiplesActividadesAplicacionThunk(payload),
      );
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(
          getActividadesAplicacionThunk({ page: 1, search: "", talento: "" }),
        );
        toast.success("Actividades creadas exitosamente");
        dispatch(closeFormModal());
      }
    } else {
      const result = await dispatch(
        updateActividadAplicacionThunk({
          id: selectedActividad.id,
          payload: editFormData,
        }),
      );
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(
          getActividadesAplicacionThunk({
            page,
            search,
            talento: talentoFilter,
          }),
        );
        toast.success("Actividad actualizada exitosamente");
        await dispatch(getActividadAplicacionByIdThunk(selectedActividad.id));
        dispatch(openViewModal());
      }
    }
  };

  return (
    <Modal
      open={formModalOpen}
      onClose={() => dispatch(closeFormModal())}
      title={formMode === "create" ? "Crear actividades" : "Editar actividad"}
      size="lg"
    >
      {formLoading ? (
        <Loader
          center
          type="dots"
          text={
            formMode === "create"
              ? "Creando actividades..."
              : "Actualizando actividad..."
          }
        />
      ) : (
        <form onSubmit={handleSubmit}>
          {formError && <Alert message={formError} variant="error" />}

          {formMode === "edit" ? (
            <>
              <div className="mb-3">
                <label className="form-label fw-medium">
                  Talento <span className="text-danger">*</span>
                </label>
                <Select2
                  value={editFormData.talento}
                  onChange={(value) =>
                    setEditFormData((prev) => ({
                      ...prev,
                      talento: value || null,
                    }))
                  }
                  fetchOptions={fetchTalentos}
                  placeholder="Selecciona un talento"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-medium">
                  Actividad <span className="text-danger">*</span>
                </label>
                <textarea
                  className="form-control"
                  name="nombre"
                  value={editFormData.nombre}
                  onChange={(e) =>
                    setEditFormData((prev) => ({
                      ...prev,
                      nombre: e.target.value,
                    }))
                  }
                  placeholder="Ingrese la actividad"
                  rows="4"
                  required
                />
              </div>

              
            </>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label fw-medium">
                  Talento <span className="text-danger">*</span>
                </label>
                <Select2
                  value={createFormData.talento}
                  onChange={(value) =>
                    setCreateFormData((prev) => ({
                      ...prev,
                      talento: value || null,
                    }))
                  }
                  fetchOptions={fetchTalentos}
                  placeholder="Selecciona un talento"
                  required
                />
              </div>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <label className="form-label fw-medium mb-0">
                    Actividades <span className="text-danger">*</span>
                  </label>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                    onClick={handleAddActividad}
                  >
                    <Icon icon="mdi:plus" width="16" />
                    Agregar
                  </button>
                </div>

                {createFormData.actividades.map((item, index) => (
                  <div key={index} className="d-flex gap-2 mb-2">
                    <textarea
                      className="form-control"
                      value={item.actividad}
                      onChange={(e) =>
                        handleActividadChange(index, e.target.value)
                      }
                      placeholder={`Actividad ${index + 1}`}
                      rows="2"
                    />
                    {createFormData.actividades.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleRemoveActividad(index)}
                        style={{ minWidth: "40px" }}
                      >
                        <Icon icon="mdi:delete-outline" width="18" />
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="d-flex justify-content-end gap-2">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => dispatch(closeFormModal())}
            >
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              {formMode === "create" ? "Crear actividades" : "Guardar cambios"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default ActivitiesApplicationFormModal;
